import React, { useEffect, useState, useContext } from 'react';
import { Form, Row, Col, message } from 'antd';
import { where } from "firebase/firestore";

import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import { DOCUMENT_PRODUCT, LISTENER_PRODUCTS } from '../../../shared/types/firestoreType';

import { ModalContext } from '../../../shared/context/ModalContext';
import { PAGINATION } from '../../../shared/types/paginationType';
import { PRODUCT } from '../../../shared/types/productType';
import global from '../../../shared/utility/global';

import Header from './Header';
import Filter from './Filter';
import Items from './Items';
import ModalForm from './ModalForm/Index';

export default function Index(_) {
    const modal = useContext(ModalContext);
    const productFirestore = new CommonCloudFirestore(DOCUMENT_PRODUCT, ['detail']);

    const [filterForm] = Form.useForm();
    const [productType, setProductType] = useState(PRODUCT);

    const [pagination, setPagination] = useState({ ...PAGINATION, size: 12 });
    const [products, setProducts] = useState([]);

    const [openForm, setOpenForm] = useState(false);
    const [id, setId] = useState(undefined);

    useEffect(() => {
        filterForm.setFieldsValue({
            productType: PRODUCT,
            keyword: ''
        });
        onLoad();
    }, []);

    useEffect(() => {
        onLoad();
    }, [productType]);

    const onLoad = async () => {
        setPagination({ ...pagination, loading: true });
        const condition = where("productType", "==", filterForm.getFieldValue('productType'));
        const items = await productFirestore.getDocuments(condition);
        setProducts(items.sort(global.orderBy('registerDate')).reverse());
        onPagination({ ...pagination }, items);
    };

    const onPagination = (_pagination, items) => {
        const formValues = filterForm.getFieldValue();
        const filtered = (items ?? products).filter(item => {
            return global.formatSearch(item.name).match(global.formatSearch(formValues.keyword));
        });
        setPagination(global.localPagination(_pagination, filtered));
    };

    const onVisible = async (item) => {
        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            await productFirestore.upateDocument(item.id, { visible: !item.visible }, );
            onLoad();
        });
    };

    const onHighlighted = async (item) => {
        modal.confirm('¿Esta seguro de realizar la acción?', async () => {
            var documentData = { highlighted: !item.highlighted };
            var result = await productFirestore.setDocument(item.id, documentData, [LISTENER_PRODUCTS]);
            if (!result) {
                message.error('Error al actualizar la información.');
                return;
            }
            message.success('Proceso exitoso.');
            onLoad();
        });
    };

    const onDelete = async (item) => {
        modal.confirm(`${(productType === PRODUCT ? 'El producto' : 'La oferta')} se eliminara permanentemente. ¿Desea continuar?`, async () => {
            var result = await productFirestore.deleteDocument(item.id, [LISTENER_PRODUCTS]);

            if (result)
                message.success('Proceso realizado con éxito.');
            else
                message.error('Ocurrió un error inesperado.');

            onLoad();
        });
    };

    const onEdit = (item) => {
        setOpenForm(true);
        setId(item.id);
    };

    return (
        <Row justify='center'>
            <Col span={24}>
                <Header
                    onLoad={onLoad}
                    onNew={() => {
                        setOpenForm(true);
                        setId('');
                    }}
                />
                <Filter
                    form={filterForm}
                    onLoad={onLoad}
                    pagination={pagination}
                    setPagination={setPagination}
                    setProductType={setProductType}
                />
                <Items
                    pagination={pagination}
                    onVisible={onVisible}
                    onHighlighted={onHighlighted}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onPagination={onPagination}
                />
                <ModalForm
                    id={id}
                    open={openForm}
                    productType={productType}
                    onLoad={onLoad}
                    onCancel={() => {
                        setOpenForm(false)
                        setId('');
                    }}
                />
            </Col>
        </Row>
    )
}